import { State, state } from '@shared/state/store';

export function updateStore<T extends keyof State>(
  slice: T,
  updates: Partial<State[T]>,
): void {
  state[slice] = { ...(state[slice] as any), ...(updates as any) };
}
